import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    useMediaQuery,
    Typography
} from '@material-ui/core';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import { useTheme } from '@material-ui/core/styles';

function FilePreviewDialog({ open, onClose, fileUrl, fileName, fileType }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const isImage = fileType?.startsWith('image/');
    const isPdf = fileType === 'application/pdf';
    const isPreviewable = isImage || isPdf;

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName || 'dosya';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            fullScreen={fullScreen}
        >
            <DialogTitle>{fileName || 'Dosya Önizleme'}</DialogTitle>
            <DialogContent dividers>
                {isImage && (
                    <img
                        src={fileUrl}
                        alt={fileName}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '80vh',
                            display: 'block',
                            margin: 'auto'
                        }}
                    />
                )}
                {isPdf && (
                    <iframe
                        src={fileUrl}
                        title={fileName}
                        style={{
                            width: '100%',
                            height: '80vh',
                            border: 'none'
                        }}
                    />
                )}
                {!isPreviewable && (
                    <div
                        style={{
                            textAlign: 'center',
                            padding: '40px 20px',
                            borderRadius: '8px',
                            backgroundColor: '#f5f5f5',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
                        }}
                    >
                        <InsertDriveFileIcon style={{ fontSize: 64, color: '#9e9e9e' }} />
                        <Typography variant="h6" style={{ marginTop: 16 }}>
                            Bu dosya türü önizlenemiyor
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Aşağıdaki butona tıklayarak indirebilirsiniz.
                        </Typography>

                        <Button
                            variant="contained"
                            color="secondary"
                            style={{ marginTop: 24 }}
                            onClick={handleDownload}
                        >
                            Dosyayı İndir
                        </Button>
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color="secondary"
                    variant="contained"
                >
                    Kapat
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default FilePreviewDialog;
